// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               unknown
// source: qonto/spend_management/memberships/memberships/firstparty/v1/get_membership_counts.proto

/* oxlint-disable */

/** Empty request message for GetMembershipCounts.` */
export interface ApiGetMembershipCountsRequest {
  /** The organization ID. */
  readonly organizationId: string;
}

/** Response message for retrieving the number of memberships. */
export interface ApiGetMembershipCountsResponse {
  /** The number of all memberships. */
  readonly membershipsCount: number;
  /** The number of active memberships. */
  readonly activeMembershipsCount: number;
  /** The number of memberships counting towards the plan limit. */
  readonly membershipsCountingTowardsPlanLimitCount: number;
  /** The number of accountants counting towards the plan limit. */
  readonly accountantsCountingTowardsPlanLimitCount: number;
}

export const ApiGetMembershipCountsRequest: MessageFns<ApiGetMembershipCountsRequest> = {
  fromJSON(object: any): ApiGetMembershipCountsRequest {
    return { organizationId: isSet(object.organizationId) ? globalThis.String(object.organizationId) : "" };
  },

  toJSON(message: ApiGetMembershipCountsRequest): unknown {
    const obj: any = {};
    if (message.organizationId !== undefined && message.organizationId !== null) {
      obj.organizationId = message.organizationId;
    }
    return obj;
  },
};

export const ApiGetMembershipCountsResponse: MessageFns<ApiGetMembershipCountsResponse> = {
  fromJSON(object: any): ApiGetMembershipCountsResponse {
    return {
      membershipsCount: isSet(object.membershipsCount) ? globalThis.Number(object.membershipsCount) : 0,
      activeMembershipsCount: isSet(object.activeMembershipsCount)
        ? globalThis.Number(object.activeMembershipsCount)
        : 0,
      membershipsCountingTowardsPlanLimitCount: isSet(object.membershipsCountingTowardsPlanLimitCount)
        ? globalThis.Number(object.membershipsCountingTowardsPlanLimitCount)
        : 0,
      accountantsCountingTowardsPlanLimitCount: isSet(object.accountantsCountingTowardsPlanLimitCount)
        ? globalThis.Number(object.accountantsCountingTowardsPlanLimitCount)
        : 0,
    };
  },

  toJSON(message: ApiGetMembershipCountsResponse): unknown {
    const obj: any = {};
    if (message.membershipsCount !== undefined && message.membershipsCount !== null) {
      obj.membershipsCount = Math.round(message.membershipsCount);
    }
    if (message.activeMembershipsCount !== undefined && message.activeMembershipsCount !== null) {
      obj.activeMembershipsCount = Math.round(message.activeMembershipsCount);
    }
    if (
      message.membershipsCountingTowardsPlanLimitCount !== undefined &&
      message.membershipsCountingTowardsPlanLimitCount !== null
    ) {
      obj.membershipsCountingTowardsPlanLimitCount = Math.round(message.membershipsCountingTowardsPlanLimitCount);
    }
    if (
      message.accountantsCountingTowardsPlanLimitCount !== undefined &&
      message.accountantsCountingTowardsPlanLimitCount !== null
    ) {
      obj.accountantsCountingTowardsPlanLimitCount = Math.round(message.accountantsCountingTowardsPlanLimitCount);
    }
    return obj;
  },
};

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
